//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      // key: value
      startX:null,
      startY:null,   
      endX:null,
      endY:null,
      offsetX:null, //点击的X
      offsetY:null, //点击的Y
      multiple:null, //根元素font-size值
      show:false,
    }
  },
  props: {
    coordinate: { //    起点  以宽为375的设计图为例 单位是 px
      type: Object,
      default:()=>{
        return {}
      }
    },
    coordinateEnd :{ // 终点  以宽为375的设计图为例 单位是 px
      type: Object,
      default:()=>{
        return {}
      }
    },
    imgSrc:{//背景图
      type:String,
      default:'https://static.soyoung.com/sy-pre/one-1596107400733.png',
    }
  },
  created () {
    this.multiple = parseFloat(getComputedStyle(window.document.documentElement)['font-size']),
    this.assignment();
  },
  watch: {
    coordinate:{
      handler(newVal, oldVal) {
        this.assignment();  
      },
      deep: true
    }

  },
  computed: {
    accordX() {   // x轴是否在区域内
      return (this.offsetX - this.startX > 0 && this.offsetX - this.endX < 0 ||  this.offsetX == this.startX  || this.offsetX == this.endX)
    },
    accordY (){  // y轴是否在区域内
      return (this.offsetY - this.startY > 0 && this.offsetY - this.endY < 0 ||  this.offsetY == this.startY  || this.offsetY == this.endY)
    },
    style(){
      return 'left:'+ (this.offsetX - 1)+'rem;top:'+ (this.offsetY - 0.5) +'rem'
    }
  },
  methods: {
    // 单位换算
    assignment(){
      this.startX = (this.coordinate.x / 20).toFixed(4);
      this.startY = (this.coordinate.y / 20).toFixed(4);
      this.endX = parseFloat((this.coordinateEnd.x / 20).toFixed(4))
      this.endY = parseFloat((this.coordinateEnd.y / 20).toFixed(4))
    },
    // 图片点击
    loaction(e) {
      this.offsetX = (e.pageX / this.multiple).toFixed(4);
      this.offsetY = (e.pageY / this.multiple).toFixed(4);
      let data = {
        state:this.accordX && this.accordY,
        x:this.offsetX * 20,
        y:this.offsetY * 20
      }
      this.show = true
      this.$emit('clickLoaction', data)
    },
  },
}
